import { useTranslation } from "react-i18next";

import { TarifBarHeadline } from "./TarifBarHeadline";

export const RoamingCallExplanation = ({ title }: { title?: string }) => {
  const { t } = useTranslation("portal");

  return (
    <TarifBarHeadline
      title={title}
      tooltipContent={
        <>
          <span className="mb-1 block text-body-sm font-semibold">
            {t("cockpit.managementTile.roaming.roamingCallHint.title")}
          </span>
          <p>{t("cockpit.managementTile.roaming.roamingCallHint.text")}</p>
        </>
      }
    />
  );
};
